module.exports = __webpack_public_path__ + "static/media/tool.1fc3a3b5.png";